"use client";

import { GalleryContextProvider } from "@/contexts/gallery";
import GalleryMain from "./main";
import GallerySectionContextProviders from "./contexts";
import { GalleryContentProps } from "./types/common";

export default function GalleryContent({ data }: GalleryContentProps) {
  return (
    <GalleryContextProvider>
      <GallerySectionContextProviders data={data}>
        <GalleryMain data={data} />
      </GallerySectionContextProviders>
    </GalleryContextProvider>
  );
}
